module.exports = __webpack_public_path__ + "img/23_80.40b802e7.png";